import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { Avatar } from '../atoms/Avatar'
import { TimePicker } from '../atoms/TimePicker'
import { CustomCheckbox } from '../atoms/CustomCheckbox'
import { TableRow } from './Table'
import styled from 'styled-components'
import { spacing } from '../theme'

const Label = styled.label`
   display: flex;
   align-items: center;
   margin: ${spacing.sm} 0;
   cursor: pointer;
   & div {
      margin: 0 ${spacing.m} 0 0;
      display: flex;
      align-items: center;
   }
`

const InputWrapper = styled.div`
   display: flex;
   align-items: center;
`

export const ChildWithTimeSelect = ({
   child,
   dropOff,
   pickUp,
   isChecked = false,
   onChange
}) => {
   const [dropOffTime, setDropOffTime] = useState(dropOff)
   const [pickUpTime, setPickUpTime] = useState(pickUp)
   const [isChoosen, setIsChoosen] = useState(isChecked)

   useEffect(() => {
      const data = {
         child: child,
         picked: isChoosen,
         dropOff: dropOffTime,
         pickUp: pickUpTime
      }
      if (typeof onChange === 'function' && data) {
         onChange(data)
      }
   }, [isChoosen, pickUpTime, dropOffTime])

   return (
      <TableRow>
         <Label>
            <CustomCheckbox
               checked={isChoosen}
               onChange={e => {
                  setIsChoosen(!isChoosen)
               }}
               type={'checkbox'}
               value={child.id}
            />
            <div>
               <Avatar
                  size={'medium'}
                  name={child.name}
                  childOrder={child.order}
               />
               <span>{child.name}</span>
            </div>
         </Label>
         <InputWrapper>
            <TimePicker
               pickedTime={dropOffTime}
               startTime={'07:30'}
               endTime={'14:00'}
               onChange={e => {
                  setDropOffTime(e)
               }}
            />
         </InputWrapper>
         <InputWrapper>
            <TimePicker
               pickedTime={pickUpTime}
               startTime={dropOffTime ? dropOffTime : '11:00'}
               endTime={'17:30'}
               onChange={e => {
                  setPickUpTime(e)
               }}
            />
         </InputWrapper>
      </TableRow>
   )
}

ChildWithTimeSelect.propTypes = {
   /**
    * Child data
    */
   child: PropTypes.object.isRequired,
   /**
    * Drop off time, string '07:00'
    */
   dropOff: PropTypes.string,
   /**
    * Pick up time, string '15:00'
    */
   pickUp: PropTypes.string,
   /**
    * Function when child status is changed
    */
   onChange: PropTypes.func
}

ChildWithTimeSelect.defaultProps = {
   child: {},
   dropOff: '07:00',
   pickUp: '15:00',
   onChange: undefined
}
